import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import '../styles/AdminPage.css';

const ADMIN_PASSWORD = 'ecolimpieza2026';

const AdminPage = () => {
  const [autenticado, setAutenticado] = useState(false);
  const [password, setPassword] = useState('');
  const [errorLogin, setErrorLogin] = useState('');
  const [comentarios, setComentarios] = useState([]);
  const [filtro, setFiltro] = useState('pendiente');
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    if (autenticado) cargarComentarios();
  }, [autenticado, filtro]);

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setAutenticado(true);
      setErrorLogin('');
    } else {
      setErrorLogin('Contraseña incorrecta.');
    }
  };

  const cargarComentarios = async () => {
    setCargando(true);
    const { data, error } = await supabase
      .from('comentarios')
      .select('*')
      .eq('estado', filtro)
      .order('created_at', { ascending: false });

    if (!error && data) setComentarios(data);
    setCargando(false);
  };

  const cambiarEstado = async (id, nuevoEstado) => {
    const { error } = await supabase
      .from('comentarios')
      .update({ estado: nuevoEstado })
      .eq('id', id);

    if (!error) {
      setComentarios((prev) => prev.filter((c) => c.id !== id));
    }
  };

  const formatFecha = (fecha) => {
    return new Date(fecha).toLocaleString('es-PE', {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  // LOGIN
  if (!autenticado) {
    return (
      <div className="admin-login">
        <div className="admin-login-box">
          <div className="admin-login-logo">🌱</div>
          <h2>Panel de Administración</h2>
          <p>Ecolimpieza Perú A&G</p>
          <form onSubmit={handleLogin}>
            <input
              type="password"
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
            />
            {errorLogin && <span className="login-error">{errorLogin}</span>}
            <button type="submit">Ingresar</button>
          </form>
        </div>
      </div>
    );
  }

  // PANEL
  return (
    <div className="admin-page">
      <div className="admin-header">
        <div className="admin-header-content">
          <h1>🌱 Panel de Moderación</h1>
          <p>Ecolimpieza Perú A&G — Comentarios</p>
          <button className="btn-logout" onClick={() => setAutenticado(false)}>
            Cerrar sesión
          </button>
        </div>
      </div>

      <div className="admin-content">
        {/* Filtros */}
        <div className="admin-filtros">
          {['pendiente', 'aprobado', 'rechazado'].map((estado) => (
            <button
              key={estado}
              className={`filtro-btn ${filtro === estado ? 'active' : ''}`}
              onClick={() => setFiltro(estado)}
            >
              {estado.charAt(0).toUpperCase() + estado.slice(1)}
            </button>
          ))}
        </div>

        {/* Lista */}
        {cargando ? (
          <div className="admin-loading">Cargando comentarios...</div>
        ) : comentarios.length === 0 ? (
          <div className="admin-empty">No hay comentarios {filtro}s.</div>
        ) : (
          <div className="admin-lista">
            {comentarios.map((c) => (
              <div key={c.id} className="admin-card">
                <div className="admin-card-info">
                  <div className="admin-card-meta">
                    <span className="admin-nombre">{c.nombre}</span>
                    <span className="admin-email">{c.email}</span>
                    <span className="admin-fecha">{formatFecha(c.created_at)}</span>
                  </div>
                  <p className="admin-comentario">"{c.comentario}"</p>
                </div>
                <div className="admin-card-actions">
                  {filtro !== 'aprobado' && (
                    <button
                      className="btn-aprobar"
                      onClick={() => cambiarEstado(c.id, 'aprobado')}
                    >
                      ✓ Aprobar
                    </button>
                  )}
                  {filtro !== 'rechazado' && (
                    <button
                      className="btn-rechazar"
                      onClick={() => cambiarEstado(c.id, 'rechazado')}
                    >
                      ✕ Rechazar
                    </button>
                  )}
                  {filtro !== 'pendiente' && (
                    <button
                      className="btn-pendiente"
                      onClick={() => cambiarEstado(c.id, 'pendiente')}
                    >
                      ↩ Pendiente
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPage;
